import { useSelector } from "react-redux";

import { getDesignerNodeDataByIdSelector } from "@skilitics/nautilus-core-designer-data";

export const useGetByIdMultilingual = () => useSelector(getDesignerNodeDataByIdSelector);
